import { CLASS_ASIDE_PANEL } from '../../constants';

export const CLASS_ASIDE_PANEL_TITLE = CLASS_ASIDE_PANEL + '__title';
